@if (isLoading) {
  <div class="position-fixed top-0 start-0 w-100 h-100 z-3 d-flex align-items-center justify-content-center bg-dark bg-opacity-50" style="backdrop-filter: blur(4px);">
    <div class="d-flex flex-column align-items-center">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
      @if (message) {
        <p class="mt-3 fs-5 fw-semibold text-white">{{ message }}</p>
      }
    </div>
  </div>
}
